import { useMemo } from 'react';
import { useOrganizationMembersQuery } from '../organizations/useOrganizationMembersQuery';
import { useCurrentUser } from '../rest-api/hooks/useCurrentUser';
import { resolveTaskAssignees, type TaskAssignee } from './taskAssignees';

/**
 * The people a task's `assignee_ids` names, with the name to show for each — see
 * `resolveTaskAssignees`. Takes the column as stored, or a single id from a picker.
 */
export const useTaskAssignees = (assigneeIds: string | null | undefined): TaskAssignee[] => {
  const { data: currentUser } = useCurrentUser();
  const { data: members } = useOrganizationMembersQuery();

  return useMemo(
    () => resolveTaskAssignees(assigneeIds, { currentUser, members }),
    [assigneeIds, currentUser, members],
  );
};
